import React from "react";
import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import dayjs from "dayjs";
import { connect } from "react-redux";

import { formatDateMmDdYyyy } from "../../helpers/dateHelper";
import { getAuthUser } from "../../redux";
import { HubContextMenu } from "../HubContextMenu";
import { UserDetailIcon } from "../UserDetailIcon";
import CommentContextItem from "./CommentContextItem";

export const FieldContextMenuUnwrapped = ({
  fieldName,
  anchorEl,
  onClose = () => {},
  user = {},
}) => {
  const open = Boolean(anchorEl);
  const { getValues, setValue } = useFormContext();

  const highlightedFields = getValues("highlightedFields") || [];

  const highlighted = highlightedFields?.find(
    ({ fieldKey }) => fieldKey === fieldName
  );

  const setHighlighted = (newHighlights) => {
    setValue("highlightedFields", newHighlights, {
      shouldDirty: true,
    });
    onClose();
  };

  const toggleHighlight = () => {
    const newHighlights = !!highlighted
      ? highlightedFields.filter(({ fieldKey }) => fieldKey !== fieldName)
      : [
          ...highlightedFields,
          {
            fieldKey: fieldName,
            createdAt: dayjs().utc().format("MM/DD/YYYY"),
            user,
          },
        ];

    setHighlighted(newHighlights);
  };

  const onComment = ({ comment = "" }) => {
    const oldHighlights = highlightedFields.filter(
      ({ fieldKey }) => fieldKey !== fieldName
    );
    const newFields = [
      ...oldHighlights,
      {
        fieldKey: fieldName,
        user,
        createdAt: dayjs().utc().format("MM/DD/YYYY"),
        comment,
      },
    ];

    setHighlighted(newFields);
  };

  const onSelect = (item) => {
    switch (item?.id) {
      case "highlight":
        toggleHighlight();
        break;
      case "removeComment":
        break;
      default:
        break;
    }
  };

  const MENU_ITEMS = [
    {
      id: "highlight",
      label: !!highlighted ? "Remove Highlight" : "Highlight",
      icon: "Edit",
    },
    !!highlighted?.comment && {
      id: "removeComment",
      label: "Remove Comment",
      icon: "MessageSquare",
    },
  ].filter(Boolean);

  const EndElements = (
    <Stack width="100%" padding="8px 14px" gap="5px">
      {highlighted?.user && (
        <UserDetailIcon
          size={16}
          user={{
            name: highlighted?.user?.name,
            email: highlighted?.user?.email,
            hueShift: highlighted?.user?.id,
          }}
          includeEmail={false}
          variant="rounded"
        />
      )}
      {highlighted?.createdAt && (
        <Typography variant="caption11">
          Highlighted on {formatDateMmDdYyyy(highlighted?.createdAt)}
        </Typography>
      )}
    </Stack>
  );

  const size = "12px";
  return (
    <HubContextMenu
      id={"field"}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      HubIconProps={{ size: 14 }}
      overrideOpen={open}
      overrideAnchorEl={anchorEl}
      onClose={onClose}
      IconButtonProps={{ sx: { display: "none " } }}
      {...(!!highlighted && !highlighted?.comment ? { EndElements } : {})}
      MenuProps={{
        sx: {
          "& .MuiMenuItem-root": {
            "& .MuiListItemIcon-root": {
              minWidth: "24px",
              svg: {
                width: `${size} !important`,
                height: `${size} !important`,
              },
            },
            "& .MuiListItemText-root": {
              "& .MuiTypography-root": {
                fontSize: size,
              },
            },
          },
        },
      }}
    >
      {!highlighted?.comment && (
        <CommentContextItem handleComment={onComment} />
      )}
    </HubContextMenu>
  );
};

const mapStateToProps = (state) => ({
  user: getAuthUser(state),
});

export const FieldContextMenu = connect(mapStateToProps)(
  FieldContextMenuUnwrapped
);
